import {FC} from 'react'
import {useNavigate} from 'react-router-dom'
import {Button} from 'shared/ui/buttons'
import {Close} from 'shared/ui/icons'
import styles from './styles.module.scss'

export const Header: FC<{isShow?: boolean, setIsShow: (isShow: boolean) => void}> = ({isShow, setIsShow}) => {
  const navigate = useNavigate()

  const closeHandler = () => setIsShow(false)

  if (!isShow) return <></>

  return (
    <div className={styles.container}>
      <div />
      <div>
        <span className={styles.title}>A personalized gift for you! 20 FREE CREDITS</span>
        <Button className={styles.getBtn} styleType='primary' onClick={() => navigate('/register')}>GET</Button>
      </div>
      <div className={styles.closeIcon} onClick={closeHandler}> <Close /> </div>
    </div>
  )
}